var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMapActive = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 32,
    rx: 3,
    fill: "#0078A8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3565 23.9156L17.3543 21.1875L12.9974 23.9031C12.553 24.1801 12 23.8301 12 23.2718V11.6369C12 11.376 12.1282 11.1351 12.3359 11.0056L16.9924 8.10322C17.0922 8.03834 17.2088 8.00107 17.3333 8.00107C17.4453 8.00107 17.5508 8.03118 17.6435 8.08439L22.6457 10.8125L27.0026 8.09688C27.447 7.81987 28 8.16991 28 8.72825V20.3631C28 20.624 27.8718 20.8649 27.6641 20.9944L23.0076 23.8968C22.9078 23.9617 22.7912 23.9989 22.6667 23.9989C22.5547 23.9989 22.4492 23.9688 22.3565 23.9156ZM22 12.0864L18 9.90484V19.9136L22 22.0952V12.0864ZM23.3333 12.0589V22.0187L26.6667 19.9411V9.9813L23.3333 12.0589ZM16.6667 9.9813L13.3333 12.0589V22.0187L16.6667 19.9411V9.9813Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMapActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/map-active.579e401a196bad865962b38ad1c1878b.svg";